import { topicsItems } from '@/mocks/homeMangaData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按题材和热度分类的漫画专题标签，快速找到你喜欢的类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#index');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-3 bg-background-50 hover:bg-background-100 border border-background-200/70 hover:border-primary-200 rounded-xl p-4 transition-all duration-300 cursor-pointer"
            >
              <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <span className="block text-sm font-semibold text-foreground-800 truncate">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}